import { createFileRoute } from '@tanstack/react-router'
import { DetectionsPage } from '@bloo-team/product-vantage'
import type { DetectionsSearch } from '@bloo-team/product-vantage'

/**
 * Composer shim (S5.0, docs/modularization.md §Route mounting): route
 * infrastructure stays in the app's tree; the surface lives in
 * @bloo-team/product-vantage. The URL params are the registry's filter state —
 * `?tab=suppression` opens the tuning layer, `?sel=` the detail panel.
 */
function DetectionsRoute() {
  const { clusterId, scopeId } = Route.useParams()
  const search = Route.useSearch()
  return <DetectionsPage clusterId={clusterId} scopeId={scopeId} search={search} />
}

/** A URL page/size: a positive integer, else nothing. */
function positiveInt(v: unknown): number | null {
  const n = typeof v === 'number' ? v : typeof v === 'string' ? Number(v) : NaN
  return Number.isInteger(n) && n > 0 ? n : null
}

export const Route = createFileRoute('/$clusterId/$scopeId/vantage/detections')({
  validateSearch: (search: Record<string, unknown>): DetectionsSearch => ({
    ...(search.tab === 'suppression' ? { tab: 'suppression' as const } : {}),
    ...(typeof search.sel === 'string' && search.sel ? { sel: search.sel } : {}),
    ...(typeof search.kind === 'string' && search.kind ? { kind: search.kind } : {}),
    ...(search.status === 'enabled' || search.status === 'disabled' ? { status: search.status } : {}),
    ...(typeof search.origin === 'string' && search.origin ? { origin: search.origin } : {}),
    ...(typeof search.stage === 'string' && search.stage ? { stage: search.stage } : {}),
    ...(typeof search.tactic === 'string' && search.tactic ? { tactic: search.tactic } : {}),
    ...(typeof search.technique === 'string' && search.technique ? { technique: search.technique } : {}),
    ...(typeof search.folder === 'string' && search.folder ? { folder: search.folder } : {}),
    ...(typeof search.q === 'string' && search.q ? { q: search.q } : {}),
    ...(search.silent === true || search.silent === 'true' ? { silent: true as const } : {}),
    ...(positiveInt(search.page) ? { page: positiveInt(search.page) as number } : {}),
    ...(positiveInt(search.size) ? { size: positiveInt(search.size) as number } : {}),
  }),
  component: DetectionsRoute,
})
